import { useState, useEffect } from "react"
import PortfolioList from "../portfolioList/PortfolioList"
import "./Portfolio.scss"
import portfolioData from "./portfolioData"

export default function Portfolio() {

  // Default category selection
  const [selected, setSelected] = useState("featured")

  // Get Portfolio Data
  const [data, setData] = useState([])
  
  const listCategories = [
    {
      id: 'featured',
      title: 'Featured',
    },
    {
      id: 'web',
      title: 'Web App',
    },
    {
      id: 'mobile',
      title: 'Mobile App',
    },
    {
      id: 'desktop',
      title: 'Desktop App',
    },
    {
      id: 'design',
      title: 'UX Design',
    },
    {
      id: '',
      title: 'All',
    },
  ]


  // Get portfolio data by selected category tab
  useEffect ( () => {

    setData(portfolioData.filter((data) => data.tags.includes(selected)))

  },[selected])


  return (
    <div className="portfolio" id="portfolio">
        <h1>Portfolio</h1>
        <ul>
          {listCategories.map((item) => (
            <PortfolioList 
              id={item.id}
              title={item.title} 
              active={selected === item.id} 
              setSelected={setSelected}/>
          ))}
        </ul>

        <div className="item-container">
          {data.map((d) => (
            <div className="item" key={d.id}>
            <img 
            src={d.img} alt={d.title} />
            <h3><a href={d.url} target="_blank" rel="noreferrer" alt={d.title} >{d.title}</a></h3>
          </div>
          ))}
          
        </div>
    </div>
  )
}
